/* eslint-disable no-param-reassign */
import React, { useEffect, useState } from 'react';

import { Button, Grid, makeStyles, Typography } from '@material-ui/core';

import IconRadiologyReport from '../../assets/images/ic-radiology-report.svg';
import SimpleTooltip from '../simpleTooltip/SimpleTooltip';

const useStyles = makeStyles((theme) => {
  return {
    descriptionTypography: {
      color: '#999999',
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: '24px',
      margin: '12px 0 0',
      textAlign: 'left',
    },
    iconRadiology: {
      height: '30px',
      width: '30px',
    },
    parentContainer: {
      maxWidth: '600px',
      width: '100%',
      [theme.breakpoints.up('md')]: {
        width: '90%',
      },
    },
    statsContainer: {
      background: '#F5F5F5',
      borderRadius: '10px',
      fontSize: '11px',
      padding: '7px 14px',
      textAlign: 'left',
    },
    statsText: {
      fontSize: '12px',
      fontWeight: 'bold',
      overflowWrap: 'break-word',
    },
    tooltipContainer: {
      marginLeft: '10px',
    },
    typographyRemove: {
      color: '#B12A2A',
      cursor: 'pointer',
      fontSize: '12px',
    },
    typographyTitle: {
      color: '#172B4D',
      fontSize: '14px',
      fontWeight: 'bold',
      lineHeight: '16px',
      marginLeft: '12px',
    },
    uploadActions: {
      marginTop: '4px',
    },
  };
});

export default ({ onReportUpload, onOpenRadiologyReportDialog, filesStatus, onRemoveReport, radiologyReportRequired }) => {
  const classes = useStyles();
  const [uploadedReport, setUploadedReport] = useState(null);

  const handleReportChange = (evt) => {
    setUploadedReport([...evt.target.files]);
    evt.target.value = null;
  };

  useEffect(() => {
    if (uploadedReport) {
      onReportUpload(uploadedReport);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uploadedReport]);

  const renderReportField = () => {
    if (!filesStatus?.reportUploaded) {
      return (
        <Grid container justify="flex-start" alignItems="center">
          <Grid item>
            <Button onClick={onOpenRadiologyReportDialog} variant="outlined" component="span" color="primary">
              Upload Radiology Report
            </Button>
          </Grid>
          <Grid item>
            <div className={classes.tooltipContainer}>
              <SimpleTooltip title="If you have been given a physical radiology report, you can take a photo of this report and upload it as an image." />
            </div>
          </Grid>
        </Grid>
      );
    }
    return (
      <div className={classes.parentContainer}>
        <Grid container className={classes.statsContainer}>
          {filesStatus.uploadedReport.map((file, index) => (
            <Grid id={`${file.name}_${index}`} item xs={12}>
              <Typography className={classes.statsText}> {file.name} </Typography>
            </Grid>
          ))}
        </Grid>
        <div className={classes.uploadActions} style={{ marginTop: '4px' }}>
          <input onChange={handleReportChange} hidden id="raised-button-report-change" type="file" />
          <span onClick={onRemoveReport} className={classes.typographyRemove} aria-hidden="true">
            Remove
          </span>
        </div>
      </div>
    );
  };

  return (
    <div className="text-left" style={{ marginTop: '28px' }}>
      <div className={classes.headerContainer}>
        <Grid container justify="flex-start" alignItems="center">
          <Grid item style={{ display: 'inline-flex' }}>
            <img src={IconRadiologyReport} className={classes.iconRadiology} alt="radiology icon" />
          </Grid>
          <Grid item>
            <Typography className={classes.typographyTitle}>{radiologyReportRequired ? <span style={{ color: '#E92828' }}>*</span> : null}&nbsp;Radiology Report</Typography>
          </Grid>
        </Grid>
      </div>

      <div>
        <Typography className={classes.descriptionTypography}>
          This is the text report generated by your radiologist. It may be printed on paper or come in many digital formats such as a PDF or text file. If you have a paper copy,
          then you can take a photo or digital scan of the document and upload this file.
        </Typography>
      </div>

      <div style={{ marginTop: '16px' }}>{renderReportField()}</div>
    </div>
  );
};
